var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovedStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#10B981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1562 18.3363C36.1642 17.8323 35.9962 17.4043 35.6522 17.0523C35.3002 16.6923 34.8802 16.5083 34.3922 16.5003C33.8882 16.4923 33.4602 16.6643 33.1082 17.0163L21.0722 28.6683L17.1362 24.2883C16.8002 23.9203 16.3842 23.7243 15.8882 23.7003C15.3922 23.6683 14.9602 23.8203 14.5922 24.1563C14.2242 24.4843 14.0282 24.8963 14.0042 25.3923C13.9722 25.8883 14.1242 26.3243 14.4602 26.7003L19.6442 32.4723C19.8602 32.7123 20.1282 32.8803 20.4482 32.9763C20.7602 33.0723 21.0762 33.0843 21.3962 33.0123C21.7162 32.9323 21.9962 32.7803 22.2362 32.5563L35.6162 19.5963C35.9682 19.2443 36.1482 18.8243 36.1562 18.3363Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedStatus);
export default __webpack_public_path__ + "static/media/ApprovedStatus.97ceafb260c0cd26e9ce900ddd51aae1.svg";
export { ForwardRef as ReactComponent };